/*
 * LJDP motion runtime — sticky-header scroll state + editorial scroll reveals.
 * Kept tiny on purpose. See motion.css for the durations and easings.
 */

(() => {
  // Sticky header shrink on scroll — tag when past 40px
  const headers = document.querySelectorAll(
    ".site-header, .header-wrapper, header[role='banner']"
  );
  if (headers.length) {
    const updateHeaders = () => {
      const scrolled = window.scrollY > 40;
      for (const el of headers) el.dataset.scrolled = scrolled ? 'true' : 'false';
    };
    window.addEventListener('scroll', updateHeaders, { passive: true });
    updateHeaders();
  }

  // Scroll reveal — editorial sections with [data-reveal]
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.dataset.revealed = 'true';
          io.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    for (const el of document.querySelectorAll('[data-reveal]')) io.observe(el);
  } else {
    // Fallback: reveal everything immediately
    for (const el of document.querySelectorAll('[data-reveal]')) {
      el.dataset.revealed = 'true';
    }
  }
})();
